/* MaxPrint Gift Advisor — storefront widget (v2)
   - Floating button on every page, chat panel, Arabic/English.
   - Before the first chat: language choice, then name + mobile (required) and email (optional).
   - Product cards are rendered ONLY from MaxPrint's own catalog file (never from model text).
   - "See all results" opens a grid of every catalog match from the latest searches.
   - Tools run here in the browser; the Worker only talks to the model and stores the lead. */
(function () {
  "use strict";
  var CFG = window.MXAI || {};
  var PREVIEW = false;
  try { if (/[?&]mxai=1\b/.test(location.search)) sessionStorage.setItem("mxai_preview", "1"); PREVIEW = sessionStorage.getItem("mxai_preview") === "1"; } catch (e) {}
  if (!(CFG.enabled || PREVIEW) || !CFG.endpoint || !CFG.catalog) return;
  if (window.__mxaiLoaded) return; window.__mxaiLoaded = true;

  var SITE_AR = (CFG.lang || document.documentElement.lang || "").toLowerCase().indexOf("ar") === 0;
  var WA = "971522100909";
  var API = CFG.endpoint.replace(/\/$/, "");
  var I18N = {
    ar: {
      btn: "مستشار الهدايا", title: "مستشار الهدايا", sub: "بالذكاء الاصطناعي · ماكس برنت",
      langQ: "أهلاً بك في مستشار الهدايا من ماكس برنت", langQ3: "بأي لغة تفضّل أن نتحدث؟",
      formIntro: "قبل أن نبدأ، عرّفنا بك ليتمكن فريقنا من متابعة طلبك.",
      fName: "الاسم", fPhone: "رقم الجوال / واتساب", fPhonePh: "05X XXX XXXX", fEmail: "البريد الإلكتروني", optional: "اختياري",
      fMkt: "أرسلوا لي العروض والجديد", privacy: "نستخدم بياناتك فقط للتواصل معك بخصوص طلبك.",
      start: "ابدأ المحادثة", changeLang: "English",
      eName: "اكتب اسمك", ePhone: "رقم الجوال غير صحيح", eEmail: "البريد الإلكتروني غير صحيح",
      hello: "أهلاً {name}! أخبرني بالمناسبة، ولمن الهدايا، وكم قطعة تقريباً وما ميزانيتك للقطعة — مثلاً: 50 هدية لموظفين بميزانية 100 درهم.",
      ph: "اكتب ما تحتاجه…",
      send: "إرسال", thinking: "جارٍ البحث…",
      chips: ["هدايا لموظفين بميزانية 50 درهم", "هدايا فخمة لكبار العملاء", "هدايا تقنية", "هدايا صديقة للبيئة"],
      foot: "اقتراحات بالذكاء الاصطناعي — يؤكد فريقنا الأسعار والطباعة",
      wa: "أرسل الطلب للفريق على واتساب", instock: "متوفر", oos: "غير متوفر حالياً",
      err: "حدث خطأ بسيط. حاول مرة أخرى، أو راسلنا مباشرة على واتساب.",
      busy: "هناك ضغط حالياً. حاول بعد دقيقة، أو راسلنا على واتساب.",
      reset: "محادثة جديدة", close: "إغلاق", back: "رجوع",
      seeAll: "عرض كل النتائج ({n})", allTitle: "كل النتائج", results: "{n} منتج",
      sBest: "الأنسب", sLow: "السعر: الأقل", sHigh: "السعر: الأعلى",
      waHead: "مرحباً ماكس برنت 👋\nطلب من مستشار الهدايا على الموقع:", waProducts: "المنتجات:",
      waQty: "الكمية", waBudget: "الميزانية للقطعة", waDeadline: "الموعد", waLogo: "عندي لوغو", waName: "الاسم", waPhone: "الجوال", waEmail: "الإيميل", waCompany: "الشركة", waNotes: "ملاحظات"
    },
    en: {
      btn: "Gift Advisor", title: "Gift Advisor", sub: "AI assistant · MaxPrint",
      langQ: "Welcome to the MaxPrint Gift Advisor", langQ3: "Which language would you like to chat in?",
      formIntro: "Before we start, tell us who you are so our team can follow up on your request.",
      fName: "Name", fPhone: "Mobile / WhatsApp", fPhonePh: "05X XXX XXXX", fEmail: "Email", optional: "optional",
      fMkt: "Send me offers and news", privacy: "We only use your details to contact you about your request.",
      start: "Start chat", changeLang: "العربية",
      eName: "Please enter your name", ePhone: "Please enter a valid mobile number", eEmail: "Please enter a valid email",
      hello: "Hi {name}! Tell me the occasion, who the gifts are for, roughly how many and your budget per piece — e.g. 50 staff gifts at AED 100 each.",
      ph: "Tell me what you need…",
      send: "Send", thinking: "Looking for you…",
      chips: ["Staff gifts under AED 50", "Premium VIP client gifts", "Tech gifts", "Eco-friendly gifts"],
      foot: "AI suggestions — our team confirms prices & printing",
      wa: "Send this request to our team on WhatsApp", instock: "In stock", oos: "Out of stock",
      err: "Something went wrong. Please try again, or message us on WhatsApp.",
      busy: "We're a bit busy right now. Please try again in a minute, or message us on WhatsApp.",
      reset: "New chat", close: "Close", back: "Back",
      seeAll: "See all results ({n})", allTitle: "All results", results: "{n} products",
      sBest: "Best match", sLow: "Price: low to high", sHigh: "Price: high to low",
      waHead: "Hello MaxPrint 👋\nRequest from the website Gift Advisor:", waProducts: "Products:",
      waQty: "Quantity", waBudget: "Budget per piece", waDeadline: "Deadline", waLogo: "I have a logo", waName: "Name", waPhone: "Mobile", waEmail: "Email", waCompany: "Company", waNotes: "Notes"
    }
  };

  // ---------- storage ----------
  // chat = this tab only (sessionStorage); customer profile = this browser (localStorage) so returning visitors aren't asked again
  var KEY = "mxai_v2", PKEY = "mxai_profile";
  function sget(k, store) { try { return JSON.parse(store.getItem(k) || "null"); } catch (e) { return null; } }
  function sset(k, v, store) { try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function store(n) { try { return window[n]; } catch (e) { return null; } }
  var LS = store("localStorage"), SS = store("sessionStorage");
  var profile = sget(PKEY, LS) || null;
  var saved = sget(KEY, SS) || {};
  var state = { messages: saved.messages || [], view: saved.view || [], open: !!saved.open, busy: false, seen: {}, pool: [], grid: null, step: null };
  function save() { sset(KEY, { messages: state.messages, view: state.view, open: state.open }, SS); }
  function saveProfile() { sset(PKEY, profile, LS); }
  (state.view || []).forEach(function (v) { if (v.k === "cards") v.items.forEach(function (it) { state.seen[it.h] = 1; }); if (v.k === "seen") v.h.forEach(function (h) { state.seen[h] = 1; }); });

  var LANG = profile && profile.lang ? profile.lang : (SITE_AR ? "ar" : "en");
  var T = I18N[LANG];
  function shopUrl() { return location.origin + (LANG === "ar" ? "/ar" : ""); }
  function fmt(s, o) { return s.replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ""; }); }
  function uid() { var a = new Uint8Array(12); (window.crypto || window.msCrypto).getRandomValues(a); return "mx-" + Array.prototype.map.call(a, function (b) { return ("0" + b.toString(16)).slice(-2); }).join(""); }
  function firstName() { return profile && profile.name ? profile.name.split(/\s+/)[0] : ""; }

  // ---------- catalog ----------
  var CAT = null, catPromise = null;
  function catalog() {
    if (CAT) return Promise.resolve(CAT);
    if (!catPromise) catPromise = fetch(CFG.catalog, { credentials: "omit" }).then(function (r) { return r.json(); }).then(function (b) {
      var byH = {}; var items = b.items.map(function (r) {
        var cat = r.c >= 0 && b.cats[r.c] ? b.cats[r.c] : null;
        var o = { h: r.h, t: r.t, y: r.y || "", g: r.g || [], p: r.p, q: r.q, s: !!r.s,
          i: r.i ? (r.i.indexOf("http") === 0 ? r.i : b.ip + r.i) : "",
          ce: cat ? cat[0] : "", ca: cat ? cat[1] : "" };
        o.lt = norm(o.t); o.lx = norm(o.y + " " + o.g.join(" ") + " " + o.ce);
        o.base = o.t.replace(/\s[-–—]\s[^-–—]+$/, "").toLowerCase();
        byH[o.h] = o; return o;
      });
      CAT = { items: items, byH: byH, cats: b.cats.map(function (c) { return c[0]; }) };
      return CAT;
    });
    return catPromise;
  }
  function norm(s) { return " " + String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ") + " "; }

  var STOP = { gift: 1, gifts: 1, corporate: 1, for: 1, with: 1, and: 1, the: 1, a: 1, of: 1, custom: 1, branded: 1, logo: 1, printed: 1, printing: 1, set: 0, item: 1, items: 1, product: 1, products: 1, premium: 0, best: 1, good: 1, nice: 1, cheap: 1 };
  var SYN = {
    bottle: ["bottle", "flask", "tumbler", "thermos"], flask: ["flask", "bottle", "thermos"], tumbler: ["tumbler", "mug", "flask"],
    mug: ["mug", "cup"], cup: ["cup", "mug"], powerbank: ["powerbank", "power bank"], charger: ["charger", "charging"],
    earbuds: ["earbuds", "earbud", "earphones", "tws"], headphones: ["headphone", "headphones", "headset"],
    notebook: ["notebook", "diary", "journal", "notepad"], diary: ["diary", "notebook", "planner"],
    bag: ["bag", "tote", "backpack", "pouch"], backpack: ["backpack", "bag"], tote: ["tote", "shopping bag"],
    pen: ["pen", "ballpoint", "rollerball", "pens"], award: ["award", "trophy", "plaque", "crystal"], trophy: ["trophy", "award"],
    keychain: ["keychain", "keyring", "key holder", "keyholder"], wallet: ["wallet", "cardholder", "card holder"],
    cap: ["cap", "hat"], shirt: ["shirt", "t shirt", "tshirt", "polo"], tshirt: ["t shirt", "tshirt", "shirt"],
    eco: ["eco", "bamboo", "recycled", "sustainable", "cork", "rpet"], tech: ["tech", "technology", "wireless", "usb", "bluetooth"],
    speaker: ["speaker"], umbrella: ["umbrella"], lanyard: ["lanyard"], desk: ["desk", "organizer", "organiser"], lamp: ["lamp", "light"]
  };
  function stem(w) { return w.length > 4 && /s$/.test(w) && !/ss$/.test(w) ? w.slice(0, -1) : w; }

  var POOL_PER_SEARCH = 48, POOL_MAX = 72;
  function search(a) {
    var q = String(a.query || "").toLowerCase().replace(/power\s+bank/g, "powerbank").replace(/t-shirt/g, "tshirt");
    var words = q.split(/[^a-z0-9]+/).filter(function (w) { return w && !STOP[w]; });
    var groups = words.map(function (w) { var s = stem(w); var alts = (SYN[w] || SYN[s] || [s]).slice(); if (alts.indexOf(s) < 0) alts.push(s); return alts; });
    var catF = a.category ? String(a.category).toLowerCase() : "";
    var maxP = typeof a.max_price_aed === "number" ? a.max_price_aed : null;
    var minP = typeof a.min_price_aed === "number" ? a.min_price_aed : null;
    var stockOnly = a.in_stock_only !== false;
    var limit = Math.max(1, Math.min(12, parseInt(a.limit || 8, 10) || 8));
    var validCat = catF && CAT.cats.some(function (c) { return c.toLowerCase() === catF; });
    var res = [];
    CAT.items.forEach(function (o) {
      if (validCat && o.ce.toLowerCase() !== catF) return;
      if (maxP !== null && o.p > maxP) return;
      if (minP !== null && o.q < minP) return;
      if (stockOnly && !o.s) return;
      var sc = 0, hitGroups = 0;
      groups.forEach(function (alts) {
        var best = 0;
        alts.forEach(function (w) {
          var pat = " " + w;
          if (o.lt.indexOf(pat + " ") >= 0 || o.lt.indexOf(pat + "s ") >= 0) best = Math.max(best, 3);
          else if (o.lt.indexOf(pat) >= 0) best = Math.max(best, 2);
          else if (o.lx.indexOf(pat) >= 0) best = Math.max(best, 1.5);
        });
        if (best) hitGroups++; sc += best;
      });
      if (groups.length && !hitGroups) return;
      if (groups.length > 1 && hitGroups === groups.length) sc += 3;
      if (o.lt.indexOf(" " + words.join(" ") + " ") >= 0 && words.length > 1) sc += 4;
      if (o.s) sc += 0.5;
      res.push([sc, o]);
    });
    res.sort(function (x, y) { return y[0] - x[0] || (maxP !== null ? y[1].p - x[1].p : x[1].p - y[1].p); });
    var out = [], bases = {}, poolAdded = 0;
    var inPool = {}; state.pool.forEach(function (h) { inPool[h] = 1; });
    var poolBases = {}; state.pool.forEach(function (h) { var o = CAT.byH[h]; if (o) poolBases[o.base] = 1; });
    for (var i = 0; i < res.length; i++) {
      var o = res[i][1];
      if (out.length < limit && !bases[o.base]) { bases[o.base] = 1; out.push(o); }
      // everything that matched goes to the "see all results" pool (one colour variant per product)
      if (poolAdded < POOL_PER_SEARCH && state.pool.length < POOL_MAX && !inPool[o.h] && !poolBases[o.base]) { state.pool.push(o.h); inPool[o.h] = 1; poolBases[o.base] = 1; poolAdded++; }
      if (out.length >= limit && (poolAdded >= POOL_PER_SEARCH || state.pool.length >= POOL_MAX)) break;
    }
    out.forEach(function (o) { state.seen[o.h] = 1; });
    if (out.length) { state.view.push({ k: "seen", h: out.map(function (o) { return o.h; }) }); save(); }
    return {
      total_matches: res.length,
      results: out.map(function (o) {
        return { handle: o.h, title: o.t, category: o.ce || o.y, price_aed: o.p === o.q ? String(o.p) : ("from " + o.p + " to " + o.q), in_stock: o.s };
      })
    };
  }

  // ---------- DOM ----------
  var FONT = "system-ui,-apple-system,'Segoe UI',Roboto,'Noto Sans Arabic',sans-serif";
  var css = "\
#mxai-btn{position:fixed;z-index:2147483000;bottom:96px;right:18px;display:flex;align-items:center;gap:8px;padding:12px 16px 12px 14px;border-radius:999px;border:0;background:#0b0c0a;color:#fafaf7;font:600 14px/1 " + FONT + ";box-shadow:0 10px 30px rgba(0,0,0,.28),0 0 0 2px #daff00 inset;cursor:pointer;transition:transform .2s ease}\
#mxai-btn.rtl{right:auto;left:18px}\
#mxai-btn:hover{transform:translateY(-2px)}#mxai-btn:focus-visible{outline:3px solid #daff00;outline-offset:3px}\
#mxai-btn svg{width:18px;height:18px;flex:none}\
#mxai-panel{position:fixed;z-index:2147483647;bottom:18px;right:18px;width:400px;max-width:calc(100vw - 24px);height:min(680px,calc(100vh - 36px));display:none;flex-direction:column;background:#fafaf7;color:#0b0c0a;border-radius:22px;overflow:hidden;box-shadow:0 24px 70px rgba(0,0,0,.35);font:15px/1.45 " + FONT + ";transition:width .25s ease}\
#mxai-panel[dir=rtl]{right:auto;left:18px}\
#mxai-panel.open{display:flex}#mxai-panel.wide{width:min(980px,calc(100vw - 36px))}\
#mxai-panel *{box-sizing:border-box}\
#mxai-panel ::-webkit-scrollbar{width:6px;height:6px}#mxai-panel ::-webkit-scrollbar-thumb{background:#cfd1c6;border-radius:6px}#mxai-panel ::-webkit-scrollbar-track{background:transparent}\
@media (max-width:560px){#mxai-panel,#mxai-panel[dir=rtl],#mxai-panel.wide{inset:0;left:0;right:0;width:100%;max-width:100%;height:100%;height:100dvh;border-radius:0}#mxai-btn{bottom:88px}}\
.mxai-h{display:flex;align-items:center;gap:10px;padding:14px 12px 12px 14px;background:#0b0c0a;color:#fafaf7;flex:none}\
.mxai-dot{width:34px;height:34px;border-radius:50%;background:#daff00;color:#0b0c0a;display:grid;place-items:center;flex:none}.mxai-dot svg{width:18px;height:18px}\
.mxai-ht{flex:1;min-width:0}.mxai-ht b{display:block;font-size:15px}.mxai-ht span{display:block;font-size:12px;color:#a9ad9f}\
.mxai-ib{background:transparent;border:0;color:#fafaf7;cursor:pointer;padding:8px;border-radius:10px;font:500 12px " + FONT + ";white-space:nowrap}.mxai-ib:hover{background:rgba(255,255,255,.1)}.mxai-ib:focus-visible{outline:2px solid #daff00}\
.mxai-body{flex:1;overflow-y:auto;padding:14px 12px 6px;display:flex;flex-direction:column;gap:10px;overscroll-behavior:contain;scrollbar-width:thin;scrollbar-color:#cfd1c6 transparent}\
.mxai-body>*{flex-shrink:0}.mxai-m{max-width:86%;padding:10px 13px;border-radius:16px;white-space:pre-wrap;word-wrap:break-word}\
.mxai-a{align-self:flex-start;background:#fff;border:1px solid #e6e7df;border-start-start-radius:6px}\
.mxai-u{align-self:flex-end;background:#daff00;color:#0b0c0a;border-start-end-radius:6px}\
.mxai-chips{display:flex;flex-wrap:wrap;gap:8px}.mxai-chip{border:1px solid #0b0c0a;background:#fff;border-radius:999px;padding:8px 12px;font:500 13px " + FONT + ";cursor:pointer;color:#0b0c0a}.mxai-chip:hover{background:#daff00}\
.mxai-cards{display:flex;gap:10px;overflow-x:auto;padding:2px 2px 8px;scroll-snap-type:x mandatory;scrollbar-width:thin;scrollbar-color:#cfd1c6 transparent}\
.mxai-card{flex:0 0 164px;scroll-snap-align:start;background:#fff;border:1px solid #e6e7df;border-radius:16px;overflow:hidden;text-decoration:none;color:#0b0c0a;display:flex;flex-direction:column}\
.mxai-card:hover{border-color:#0b0c0a}\
.mxai-card img{width:100%;height:132px;object-fit:contain;background:#fff;display:block}\
.mxai-cb{padding:8px 10px 10px;display:flex;flex-direction:column;gap:4px}.mxai-ct{font-size:13px;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}\
.mxai-cp{font-size:14px;font-weight:700;font-variant-numeric:tabular-nums}.mxai-cs{font-size:11px;color:#3f7a17}.mxai-cs.no{color:#a33}.mxai-cr{font-size:12px;color:#5d6154;line-height:1.35}\
.mxai-more{align-self:flex-start;display:inline-flex;align-items:center;gap:6px;border:1.5px solid #0b0c0a;background:#fff;color:#0b0c0a;border-radius:999px;padding:9px 14px;font:600 13px " + FONT + ";cursor:pointer}.mxai-more:hover{background:#daff00}\
.mxai-wa{align-self:stretch;display:flex;align-items:center;justify-content:center;gap:8px;background:#25d366;color:#08240f;font-weight:700;border-radius:14px;padding:12px;text-decoration:none}\
.mxai-typing{align-self:flex-start;color:#6b7061;font-size:13px;padding:4px 6px}\
.mxai-f{padding:8px 10px 10px;border-top:1px solid #e6e7df;background:#fafaf7;flex:none}\
.mxai-row{display:flex;gap:8px;align-items:flex-end}\
.mxai-in{flex:1;min-width:0;display:block;resize:none;border:1px solid #cfd1c6;border-radius:14px;padding:11px 14px;font:16px/22px " + FONT + ";height:46px;min-height:46px;max-height:120px;overflow-y:hidden;background:#fff;color:#0b0c0a;scrollbar-width:thin}\
.mxai-in::placeholder{color:#8a8e80;opacity:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\
.mxai-in:focus{outline:2px solid #0b0c0a;outline-offset:1px}\
.mxai-send{flex:none;width:46px;height:46px;border-radius:14px;border:0;background:#0b0c0a;color:#daff00;cursor:pointer;display:grid;place-items:center}.mxai-send:disabled{opacity:.4}\
.mxai-note{font-size:11px;color:#6b7061;text-align:center;margin-top:6px}\
.mxai-on{flex:1;overflow-y:auto;padding:22px 18px;display:flex;flex-direction:column;gap:14px}\
.mxai-on h2{font:700 20px/1.3 " + FONT + ";margin:0;text-wrap:balance}.mxai-on p{margin:0;color:#4a4e42;font-size:14px}\
.mxai-welcome{display:flex;flex-direction:column;gap:18px;padding:4px 0 6px}.mxai-wl{text-align:center;display:flex;flex-direction:column;gap:6px}.mxai-wl+.mxai-wl{padding-top:18px;border-top:1px solid #e6e7df}.mxai-wl h2{font-size:19px}\
.mxai-langs{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:6px}\
.mxai-lang{border:1.5px solid #0b0c0a;background:#fff;border-radius:16px;padding:18px 10px;font:700 18px " + FONT + ";cursor:pointer;color:#0b0c0a}.mxai-lang:hover,.mxai-lang:focus-visible{background:#daff00;outline:none}\
.mxai-fld{display:flex;flex-direction:column;gap:6px}.mxai-fld label{font-size:13px;font-weight:600}.mxai-fld label small{font-weight:400;color:#6b7061}\
.mxai-fld input[type=text],.mxai-fld input[type=tel],.mxai-fld input[type=email]{border:1px solid #cfd1c6;border-radius:12px;padding:12px 14px;font:16px/1.3 " + FONT + ";background:#fff;color:#0b0c0a;width:100%}\
.mxai-fld input:focus{outline:2px solid #0b0c0a;outline-offset:1px}.mxai-fld input[aria-invalid=true]{border-color:#b3261e}\
.mxai-fld input[type=tel]{direction:ltr}#mxai-panel[dir=rtl] .mxai-fld input[type=tel]{text-align:right}\
.mxai-err{font-size:12px;color:#b3261e;min-height:0}\
.mxai-chk{display:flex;gap:10px;align-items:flex-start;font-size:13px;color:#2c2f27;cursor:pointer}.mxai-chk input{width:18px;height:18px;margin:1px 0 0;accent-color:#0b0c0a;flex:none}\
.mxai-go{border:0;background:#0b0c0a;color:#daff00;border-radius:14px;padding:14px;font:700 15px " + FONT + ";cursor:pointer}.mxai-go:disabled{opacity:.5}\
.mxai-link{align-self:center;background:none;border:0;color:#0b0c0a;text-decoration:underline;font:500 13px " + FONT + ";cursor:pointer;padding:6px}\
.mxai-gv{position:absolute;inset:0;background:#fafaf7;display:flex;flex-direction:column;z-index:2}\
.mxai-gh{display:flex;align-items:center;gap:10px;padding:12px;border-bottom:1px solid #e6e7df;flex:none;flex-wrap:wrap}\
.mxai-gh b{font-size:16px}.mxai-gh span{color:#6b7061;font-size:13px}\
.mxai-bk{border:1px solid #cfd1c6;background:#fff;border-radius:10px;padding:8px 12px;font:600 13px " + FONT + ";cursor:pointer;color:#0b0c0a}\
.mxai-sorts{display:flex;gap:6px;margin-inline-start:auto;flex-wrap:wrap}.mxai-sort{border:1px solid #cfd1c6;background:#fff;border-radius:999px;padding:6px 10px;font:500 12px " + FONT + ";cursor:pointer;color:#0b0c0a}.mxai-sort[aria-pressed=true]{background:#0b0c0a;color:#fafaf7;border-color:#0b0c0a}\
.mxai-grid{flex:1;overflow-y:auto;padding:12px;display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));grid-auto-rows:max-content;gap:10px;align-content:start;scrollbar-width:thin;scrollbar-color:#cfd1c6 transparent}\
.mxai-grid .mxai-card{flex:none;min-height:max-content}\
#mxai-panel{position:fixed}.mxai-wrap{position:relative;flex:1;display:flex;flex-direction:column;min-height:0}\
@media (prefers-reduced-motion:reduce){#mxai-btn,#mxai-panel{transition:none}}";
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  var SPARK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2l2.2 6.3L20 10.5l-5.8 2.2L12 19l-2.2-6.3L4 10.5l5.8-2.2L12 2z" fill="currentColor"/><path d="M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9L19 15z" fill="currentColor"/></svg>';
  var WAICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.6-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/></svg>';

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function fmtPrice(o) { return "AED " + (o.p === o.q ? o.p : o.p + "–" + o.q); }

  var btn = document.createElement("button"); btn.id = "mxai-btn"; btn.type = "button";
  var panel = document.createElement("div"); panel.id = "mxai-panel"; panel.setAttribute("role", "dialog");
  document.body.appendChild(btn); document.body.appendChild(panel);
  var body, input, sendB, wrap;

  function buildButton() {
    // The floating button follows the page language; the chat itself keeps the visitor's chosen language.
    var BT = I18N[SITE_AR ? "ar" : "en"];
    btn.className = SITE_AR ? "rtl" : "";
    btn.setAttribute("aria-label", BT.btn);
    btn.innerHTML = '<span style="color:#daff00">' + SPARK + "</span><span></span>";
    btn.lastChild.textContent = BT.btn;
  }
  function header(extra) {
    return '<div class="mxai-h"><div class="mxai-dot">' + SPARK + '</div><div class="mxai-ht"><b></b><span></span></div>' + (extra || "") +
      '<button class="mxai-ib" data-a="close" type="button">✕</button></div>';
  }
  function fillHeader() {
    panel.querySelector(".mxai-ht b").textContent = T.title; panel.querySelector(".mxai-ht span").textContent = T.sub;
    panel.querySelector('[data-a="close"]').setAttribute("aria-label", T.close);
    panel.querySelector('[data-a="close"]').onclick = function () { setOpen(false); };
  }
  function setDir() { panel.dir = LANG === "ar" ? "rtl" : "ltr"; panel.lang = LANG; panel.setAttribute("aria-label", T.title); }

  // ---- onboarding: language, then details ----
  function buildOnboarding() {
    setDir(); panel.classList.remove("wide");
    panel.innerHTML = header() + '<div class="mxai-on"></div>'; fillHeader();
    var on = panel.querySelector(".mxai-on");
    if (!profile || !profile.lang || state.step === "lang") {
      // bilingual welcome: the customer hasn't chosen yet, so both languages carry equal weight
      panel.querySelector(".mxai-ht b").textContent = "مستشار الهدايا · Gift Advisor";
      panel.querySelector(".mxai-ht span").textContent = "ماكس برنت · MaxPrint";
      var wl = el("div", "mxai-welcome");
      [["ar", "rtl"], ["en", "ltr"]].forEach(function (x) {
        var blk = el("div", "mxai-wl"); blk.dir = x[1]; blk.lang = x[0];
        blk.appendChild(el("h2", null, I18N[x[0]].langQ)); blk.appendChild(el("p", null, I18N[x[0]].langQ3));
        wl.appendChild(blk);
      });
      var g = el("div", "mxai-langs");
      [["ar", "العربية"], ["en", "English"]].forEach(function (x) {
        var b = el("button", "mxai-lang", x[1]); b.type = "button"; b.lang = x[0];
        b.onclick = function () { setLang(x[0]); profile = profile || {}; profile.lang = x[0]; saveProfile(); state.step = "form"; buildOnboarding(); };
        g.appendChild(b);
      });
      on.appendChild(wl); on.appendChild(g);
      setTimeout(function () { var f = g.querySelector("button"); if (f) f.focus(); }, 60);
      return;
    }
    on.appendChild(el("h2", null, T.title));
    on.appendChild(el("p", null, T.formIntro));
    var form = el("form"); form.noValidate = true; form.style.cssText = "display:flex;flex-direction:column;gap:14px";
    function field(id, label, type, opt, ph, ac) {
      var w = el("div", "mxai-fld"); var l = el("label"); l.htmlFor = id; l.textContent = label + (opt ? " " : " *");
      if (opt) { var sm = el("small", null, "(" + T.optional + ")"); l.appendChild(sm); }
      var i = el("input"); i.type = type; i.id = id; i.name = id; if (ph) i.placeholder = ph; if (ac) i.autocomplete = ac;
      i.setAttribute("data-gramm", "false"); i.setAttribute("data-enable-grammarly", "false");
      var e = el("div", "mxai-err"); e.id = id + "-err"; e.setAttribute("aria-live", "polite"); i.setAttribute("aria-describedby", e.id);
      w.appendChild(l); w.appendChild(i); w.appendChild(e); form.appendChild(w); return i;
    }
    var fN = field("mxai-name", T.fName, "text", false, "", "name");
    var fP = field("mxai-phone", T.fPhone, "tel", false, T.fPhonePh, "tel"); fP.inputMode = "tel";
    var fE = field("mxai-email", T.fEmail, "email", true, "", "email"); fE.inputMode = "email";
    var ck = el("label", "mxai-chk"); var cb = el("input"); cb.type = "checkbox"; cb.id = "mxai-mkt"; ck.appendChild(cb); ck.appendChild(el("span", null, T.fMkt)); form.appendChild(ck);
    var go = el("button", "mxai-go", T.start); go.type = "submit"; form.appendChild(go);
    form.appendChild(el("p", null, T.privacy)); form.lastChild.style.cssText = "font-size:12px;color:#6b7061";
    var sw = el("button", "mxai-link", T.changeLang); sw.type = "button"; sw.lang = LANG === "ar" ? "en" : "ar";
    sw.onclick = function () { setLang(LANG === "ar" ? "en" : "ar"); profile.lang = LANG; saveProfile(); buildOnboarding(); };
    form.appendChild(sw);
    on.appendChild(form);
    if (profile) { if (profile.name) fN.value = profile.name; if (profile.phone) fP.value = profile.phone; if (profile.email) fE.value = profile.email; cb.checked = !!profile.marketing; }
    function bad(i, msg) { i.setAttribute("aria-invalid", msg ? "true" : "false"); document.getElementById(i.id + "-err").textContent = msg || ""; return !!msg; }
    form.onsubmit = function (ev) {
      ev.preventDefault();
      var name = fN.value.replace(/\s+/g, " ").trim(), phone = fP.value.trim(), email = fE.value.trim();
      var digits = phone.replace(/\D/g, "");
      var e1 = bad(fN, name.length < 2 ? T.eName : ""), e2 = bad(fP, (digits.length < 8 || digits.length > 15 || /[^\d+\s()\-.]/.test(phone)) ? T.ePhone : ""),
        e3 = bad(fE, email && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email) ? T.eEmail : "");
      if (e1 || e2 || e3) { (e1 ? fN : e2 ? fP : fE).focus(); return; }
      profile = { id: (profile && profile.id) || uid(), lang: LANG, name: name.slice(0, 80), phone: phone.slice(0, 30), email: email.slice(0, 120), marketing: cb.checked, done: true };
      saveProfile(); go.disabled = true;
      sendLead({}).then(function () { state.step = null; buildChat(); });
    };
    setTimeout(function () { fN.focus(); }, 60);
  }
  function sendLead(extra) {
    if (!profile || !profile.done) return Promise.resolve();
    var payload = { id: profile.id, name: profile.name, phone: profile.phone, email: profile.email, lang: LANG, marketing: !!profile.marketing, page: location.pathname };
    for (var k in extra) payload[k] = extra[k];
    // the chat never waits more than a moment on this; if it fails we retry on the next open
    var p = fetch(API + "/lead", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true })
      .then(function (r) { profile.synced = r.ok; saveProfile(); }).catch(function () { profile.synced = false; saveProfile(); });
    return Promise.race([p, new Promise(function (res) { setTimeout(res, 1500); })]);
  }
  function setLang(l) { LANG = l; T = I18N[l]; buildButton(); }

  // ---- chat ----
  function buildChat() {
    setDir();
    panel.innerHTML = header('<button class="mxai-ib" data-a="reset" type="button"></button>') +
      '<div class="mxai-wrap"><div class="mxai-body" aria-live="polite"></div><div class="mxai-f"><div class="mxai-row"><textarea class="mxai-in" rows="1" data-gramm="false" data-gramm_editor="false" data-enable-grammarly="false" autocomplete="off" spellcheck="true"></textarea><button class="mxai-send" type="button"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" style="transform:' + (LANG === "ar" ? "scaleX(-1)" : "none") + '"><path d="M4 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div><div class="mxai-note"></div></div></div>';
    fillHeader();
    var rb = panel.querySelector('[data-a="reset"]'); rb.textContent = T.reset;
    rb.onclick = function () { state.messages = []; state.view = []; state.seen = {}; state.pool = []; save(); closeGrid(); renderView(); };
    wrap = panel.querySelector(".mxai-wrap"); body = panel.querySelector(".mxai-body"); input = panel.querySelector(".mxai-in"); sendB = panel.querySelector(".mxai-send");
    input.placeholder = T.ph; input.setAttribute("aria-label", T.ph); sendB.setAttribute("aria-label", T.send);
    panel.querySelector(".mxai-note").textContent = T.foot;
    input.addEventListener("keydown", function (e) { if (e.key === "Enter" && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(input.value); } });
    input.addEventListener("input", grow);
    sendB.onclick = function () { send(input.value); };
    if (state.busy) sendB.disabled = true;
    catalog().then(renderView).catch(renderView);
    setTimeout(function () { input.focus(); }, 60);
  }
  function grow() {
    input.style.height = "46px";
    var h = Math.min(120, Math.max(46, input.scrollHeight + 2));
    input.style.height = h + "px"; input.style.overflowY = input.scrollHeight > 118 ? "auto" : "hidden";
  }
  function scrollEnd() { if (body) body.scrollTop = body.scrollHeight; }

  function renderView() {
    if (!body) return;
    body.innerHTML = "";
    body.appendChild(el("div", "mxai-m mxai-a", fmt(T.hello, { name: firstName() }).replace(/\s+!/, "!")));
    if (!state.view.length) {
      var ch = el("div", "mxai-chips");
      T.chips.forEach(function (c) { var b = el("button", "mxai-chip", c); b.type = "button"; b.onclick = function () { send(c); }; ch.appendChild(b); });
      body.appendChild(ch);
    }
    state.view.forEach(drawItem);
    scrollEnd();
  }
  function card(o, reason) {
    var a = el("a", "mxai-card"); a.href = shopUrl() + "/products/" + o.h; a.target = "_self";
    var img = el("img"); img.loading = "lazy"; img.alt = o.t; img.src = o.i; a.appendChild(img);
    var cb = el("div", "mxai-cb");
    cb.appendChild(el("div", "mxai-ct", o.t)); cb.appendChild(el("div", "mxai-cp", fmtPrice(o)));
    cb.appendChild(el("div", "mxai-cs" + (o.s ? "" : " no"), o.s ? T.instock : T.oos));
    if (reason) cb.appendChild(el("div", "mxai-cr", reason));
    a.appendChild(cb); return a;
  }
  function drawItem(v) {
    if (v.k === "u") body.appendChild(el("div", "mxai-m mxai-u", v.t));
    else if (v.k === "a") body.appendChild(el("div", "mxai-m mxai-a", v.t));
    else if (v.k === "cards") {
      var row = el("div", "mxai-cards");
      v.items.forEach(function (it) { var o = CAT && CAT.byH[it.h]; if (o) row.appendChild(card(o, it.r)); });
      body.appendChild(row);
      var u = {}; v.items.concat((v.all || []).map(function (h) { return { h: h }; })).forEach(function (it) { if (CAT && CAT.byH[it.h]) u[it.h] = 1; });
      var total = Object.keys(u).length;
      if (total > v.items.length) {
        var m = el("button", "mxai-more", fmt(T.seeAll, { n: total })); m.type = "button";
        m.onclick = function () { openGrid(v); }; body.appendChild(m);
      }
    } else if (v.k === "wa") {
      var w = el("a", "mxai-wa"); w.href = v.url; w.target = "_blank"; w.rel = "noopener";
      w.innerHTML = WAICON + "<span></span>"; w.querySelector("span").textContent = T.wa; body.appendChild(w);
    }
  }
  function push(v) { state.view.push(v); if (body) { if (state.view.length === 1) renderView(); else drawItem(v); scrollEnd(); } save(); }

  // ---- "see all results" grid ----
  function openGrid(v) {
    closeGrid();
    var picks = {}; v.items.forEach(function (it, i) { picks[it.h] = i + 1; });
    // AI picks first, then the rest in relevance order
    var list = v.items.map(function (it) { return it.h; }).concat((v.all || []).filter(function (h) { return !picks[h]; }))
      .map(function (h) { return CAT.byH[h]; }).filter(Boolean);
    var reasons = {}; v.items.forEach(function (it) { reasons[it.h] = it.r; });
    var gv = el("div", "mxai-gv"); gv.setAttribute("role", "region"); gv.setAttribute("aria-label", T.allTitle);
    var gh = el("div", "mxai-gh");
    var bk = el("button", "mxai-bk", (LANG === "ar" ? "→ " : "← ") + T.back); bk.type = "button"; bk.onclick = closeGrid;
    var ttl = el("div"); ttl.appendChild(el("b", null, T.allTitle)); ttl.appendChild(document.createTextNode(" ")); ttl.appendChild(el("span", null, "· " + fmt(T.results, { n: list.length })));
    var sorts = el("div", "mxai-sorts");
    var grid = el("div", "mxai-grid");
    function draw(mode) {
      var l = list.slice();
      if (mode === "low") l.sort(function (a, b) { return a.p - b.p; });
      if (mode === "high") l.sort(function (a, b) { return b.q - a.q; });
      grid.innerHTML = ""; l.forEach(function (o) { grid.appendChild(card(o, reasons[o.h])); });
      [].forEach.call(sorts.children, function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-m") === mode ? "true" : "false"); });
      grid.scrollTop = 0;
    }
    [["best", T.sBest], ["low", T.sLow], ["high", T.sHigh]].forEach(function (s) {
      var b = el("button", "mxai-sort", s[1]); b.type = "button"; b.setAttribute("data-m", s[0]); b.onclick = function () { draw(s[0]); }; sorts.appendChild(b);
    });
    gh.appendChild(bk); gh.appendChild(ttl); gh.appendChild(sorts);
    gv.appendChild(gh); gv.appendChild(grid); wrap.appendChild(gv);
    panel.classList.add("wide"); state.grid = gv; draw("best"); bk.focus();
  }
  function closeGrid() { if (state.grid) { state.grid.remove(); state.grid = null; } panel.classList.remove("wide"); }

  // ---- open / close ----
  function thirdParty(hide) {
    // other floating widgets (respond.io chat bubble, etc.) must not sit on top of the open panel
    ["respond-io-widget", "#respondio__widget", ".respondio-webchat"].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { if (hide) { if (n.dataset.mxaiDisp === undefined) n.dataset.mxaiDisp = n.style.display || ""; n.style.display = "none"; } else if (n.dataset.mxaiDisp !== undefined) { n.style.display = n.dataset.mxaiDisp; delete n.dataset.mxaiDisp; } });
    });
  }
  function setOpen(o) {
    state.open = o; panel.classList.toggle("open", o); btn.style.display = o ? "none" : "flex"; thirdParty(o); save();
    clearInterval(state.tp); if (o) state.tp = setInterval(function () { thirdParty(true); }, 1500);
    if (!o) { closeGrid(); btn.focus(); return; }
    if (profile && profile.done) { if (profile.synced === false) sendLead({}); if (!body || !panel.contains(body)) buildChat(); else setTimeout(function () { input.focus(); }, 60); }
    else buildOnboarding();
  }
  btn.onclick = function () { setOpen(true); };
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && state.open) { if (state.grid) closeGrid(); else setOpen(false); } });

  // ---------- tools ----------
  function runTool(name, args) {
    args = args || {};
    if (name === "search_products") return search(args);
    if (name === "show_products") {
      var items = (args.items || []).filter(function (it) { return it && CAT.byH[it.handle] && state.seen[it.handle]; }).slice(0, 6)
        .map(function (it) { return { h: it.handle, r: typeof it.reason === "string" ? it.reason.slice(0, 160) : "" }; });
      var rejected = (args.items || []).length - items.length;
      if (items.length) push({ k: "cards", items: items, all: state.pool.slice() });
      return { shown: items.map(function (i) { return i.h; }), rejected_unknown_handles: rejected, more_results_button: state.pool.length > items.length ? state.pool.length : 0 };
    }
    if (name === "prepare_whatsapp_request") {
      var hs = (args.handles || []).filter(function (h) { return CAT.byH[h]; }).slice(0, 8);
      var L = [T.waHead], P = [];
      if (hs.length) { L.push("", T.waProducts); hs.forEach(function (h) { var o = CAT.byH[h]; L.push("• " + o.t + " — " + fmtPrice(o), "  " + shopUrl() + "/products/" + h); P.push(o.t + " — " + fmtPrice(o)); }); }
      L.push("");
      var who = profile && profile.done ? { name: profile.name, phone: profile.phone, email: profile.email } : {};
      var fields = [["name", T.waName, who.name || args.name], ["phone", T.waPhone, who.phone], ["email", T.waEmail, who.email], ["company", T.waCompany, args.company],
        ["quantity", T.waQty, args.quantity], ["budget_per_piece_aed", T.waBudget, args.budget_per_piece_aed], ["deadline", T.waDeadline, args.deadline],
        ["has_logo", T.waLogo, args.has_logo], ["notes", T.waNotes, args.notes]];
      var S = [];
      fields.forEach(function (f) { if (f[2]) { var line = "- " + f[1] + ": " + String(f[2]).slice(0, 300); L.push(line); if (f[0] !== "name" && f[0] !== "phone" && f[0] !== "email") S.push(line); } });
      var url = "https://wa.me/" + WA + "?text=" + encodeURIComponent(L.join("\n"));
      push({ k: "wa", url: url });
      sendLead({ request: P.concat(S).join("\n"), whatsapp: true });
      return { ready: true, note: "A WhatsApp button is now shown; the customer taps it to send. Their name, mobile and email are already included." };
    }
    return { error: "unknown_tool" };
  }

  // ---------- conversation ----------
  function post(payload) {
    return fetch(API + "/chat", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }); });
  }
  function send(text) {
    text = String(text || "").trim(); if (!text || state.busy) return;
    input.value = ""; grow();
    state.busy = true; sendB.disabled = true; state.pool = [];
    push({ k: "u", t: text });
    state.messages.push({ role: "user", content: text });
    var typing = el("div", "mxai-typing", T.thinking); body.appendChild(typing); scrollEnd();
    catalog().then(function () { return loop(0); }).catch(function () { push({ k: "a", t: T.err }); push({ k: "wa", url: "https://wa.me/" + WA }); })
      .then(function () { typing.remove(); state.busy = false; sendB.disabled = false; save(); });
  }
  function trimHistory() {
    var m = state.messages;
    if (m.length <= 40) return;
    m = m.slice(-40);
    while (m.length && !(m[0].role === "user" && typeof m[0].content === "string")) m.shift();
    state.messages = m;
  }
  function loop(n) {
    if (n > 6) return Promise.resolve();
    trimHistory();
    return post({ messages: state.messages, lang: LANG, categories: CAT.cats, customer_name: firstName() }).then(function (res) {
      if (res.__status === 429) { push({ k: "a", t: T.busy }); push({ k: "wa", url: "https://wa.me/" + WA }); return; }
      if (res.__status !== 200 || !res.content) { throw new Error("bad"); }
      state.messages.push({ role: "assistant", content: res.content });
      var results = [];
      // text that comes with a search call is "let me look…" narration — the customer doesn't need it
      var searching = res.content.some(function (b) { return b.type === "tool_use" && b.name === "search_products"; });
      res.content.forEach(function (b) {
        if (b.type === "text" && b.text && b.text.trim() && !searching) push({ k: "a", t: b.text.trim() });
        if (b.type === "tool_use") {
          var out; try { out = runTool(b.name, b.input); } catch (e) { out = { error: "tool_failed" }; }
          results.push({ type: "tool_result", tool_use_id: b.id, content: JSON.stringify(out) });
        }
      });
      if (results.length) { state.messages.push({ role: "user", content: results }); return loop(n + 1); }
    });
  }

  buildButton();
  if (state.open) setOpen(true);
})();